<template>
    <div class="import-tool">
        <Modal v-model="visible" title="提示" :mask-closable="false" width="530" :footer-hide="true" class=" top import-tool-modal2">
            <div class="box">
                <p class="text1">确定要终止协议吗？终止后，该协议内的签约产品都将自动下架且不可售卖</p>
            </div>

            <Form v-if="visible" ref="form" :model="formData" class="page-form less" :label-width="80">
                <FormItem prop="stopTime" label="终止日期" class="full" :rules="$units.formRule.objRequired('请选择')">
                    <DatePicker
                        type="date"
                        format="yyyy-MM-dd"
                        split-panels
                        v-model="formData.stopTime"
                        placeholder="请选择"
                        style="width:100%;"
                    ></DatePicker>
                </FormItem>

                <FormItem prop="stopMsg" label="终止原因" class="full" :rules="$units.formRule.required('请输入')">
                    <Input
                        type="textarea"
                        v-model="formData.stopMsg"
                        show-word-limit
                        :maxlength="100"
                        :autosize="{ minRows: 3, maxRows: 5 }"
                        placeholder=""
                    />
                </FormItem>
            </Form>

            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="save">确认</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import filter from '@/api/filter';
export default {
    props: ['initList'],
    data() {
        const _this = this;
        return {
            filter,
            visible: false,
            formData: {},
            stopTime:'',
        };
    },
    watch: {
        visible(newVal) {
            if (!newVal) {
                this.$refs.form.resetFields();
            }
        }
    },
    methods: {
        open(data) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.stopTime = data.stopTime;
            this.visible = true;
        },

        save() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                let _this = this;

                const formData = JSON.parse(JSON.stringify(this.formData));
                const startTime = this.filter.filterTime(formData.startTime, 'YYYY-MM-DD 00:00:00'); //生效日期
                const endTime = this.filter.filterTime(formData.endTime, 'YYYY-MM-DD 23:59:59'); //到期日期
                const stopTime = this.filter.filterTime(formData.stopTime, 'YYYY-MM-DD 23:59:59'); //终止日期
                if (formData.id) {
                    //编辑时校验
                    let msg = '';
                    if (formData.status == 0) {
                        //编辑页、协议状态为待生效
                        //终止日期编辑：不晚于到期日期即可
                        dayjs(stopTime).isAfter(dayjs(endTime)) ? (msg = '终止日期不晚于到期日期') : '';
                    } else if (
                        formData.status == 1 ||
                        formData.status == 2 ||
                        (formData.status == 3 && dayjs(_this.stopTime).isAfter(dayjs(startTime)))
                    ) {
                        //编辑页、协议状态为生效中/已过期
                        //终止日期编辑：需在协议有效期区间内
                        dayjs(stopTime).isBefore(dayjs(startTime)) || dayjs(stopTime).isAfter(dayjs(endTime))
                            ? (msg = '终止日期需在协议有效期区间内')
                            : ''; //到期日期
                    } else if (formData.status == 3) {
                        //终止日期在协议有效期之前的已终止协议：
                        //如果有效期改为未来了，终止日期不晚于到期日期即可，如果不是未来，则需在有效期间
                        if (dayjs(stopTime).isAfter(dayjs(endTime)) && dayjs().isAfter(dayjs(startTime))) {
                            msg = '终止日期需在协议有效期区间内';
                        } else if (dayjs(stopTime).isAfter(dayjs(endTime)) && dayjs().isBefore(dayjs(startTime))) {
                            msg = '终止日期不晚于到期日期';
                        }
                    }
                    if (msg) {
                        return this.$Message.error(msg);
                    }
                }
                let data = {
                    ...formData,
                    stopTime: this.filter.filterTime(formData.stopTime, 'YYYY-MM-DD') + ' 23:59:59'
                };

                this.$http({
                    url: '/buz/covenant/edit',
                    type: 'POST',
                    data,
                    apiPermissionCode:'pro_6_5'
                }).then(res => {
                    this.visible = false;
                    this.$notice.success('提交成功');
                    this.initList();
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
    .ivu-modal-header-inner {
        font-size: 14px;
        font-weight: bold;
        color: #3c464f;
    }
    .ivu-modal-close {
        top: 4px;
        .ivu-icon-ios-close {
            font-size: 30px;
            color: #a8adb7;
        }
    }
    .ivu-modal-header {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
    }
    .box {
        font-size: 13px;
        .text1 {
            color: #515c6f;
            margin-bottom: 15px;
        }
    }
    .ivu-modal-footer {
        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 30px;
    }
}
</style>
